<template>
  <section class="erro">
    <img src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/faixa-brilhante.png" class="efeito" />
    <video src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/icone-3d-animado.mp4" autoplay muted loop playsinline preload="auto"></video>
    <div class="quadro">
      <div class="titulo">
        <h2>
          LEVEL
          <span>MEMBER</span>
        </h2>
        <p>Essa página não existe, tente novamente ou acione nosso time de suporte</p>
      </div>
      <div class="campos">
        <BotaoPrincipal nome="Voltar ao início" @click="router.push('/')" />
        <div class="testar">
          <p>Precisa de ajuda?</p>
          <a>Fale com o suporte no chat</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router'
import BotaoPrincipal from '@/components/global/elementos/BotaoPrincipal.vue'

const router = useRouter()
</script>

<style scoped>
section.erro {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-color: var(--cor-preto);
  position: relative;
  overflow: hidden;
  padding: 0 0 0 150px;
  min-height: 100dvh;
}
img.efeito {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  max-width: 1000px;
  pointer-events: none;
  transform: scaleX(-1);
}
video {
  position: absolute;
  width: 100%;
  max-width: 450px;
  right: 150px;
  top: 100px;
  z-index: 1;
  background-color: var(--cor-preto);
  border: 10px solid var(--cor-preto);
  pointer-events: none;
  transform: scaleX(-1);
}
.quadro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  max-width: 500px;
  background-color: var(--cor-escuro-t);
  border: 2px solid var(--cor-escuro-3);
  padding: 60px 40px;
  border-radius: 8px;
  z-index: 3;
}
.titulo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titulo h2 {
  display: flex;
  font-family: var(--semibold);
  font-size: var(--f4);
  color: var(--cor-gelo);
}
.titulo h2 span {
  font-family: var(--extralight);
}
.titulo svg {
  width: 150px;
  min-width: 150px;
  margin: 0 0 15px 0;
}
.titulo p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
  text-align: center;
  width: 100%;
  max-width: 300px;
  margin: 10px 0 20px 0;
}
.campos {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
.campos .campo {
  margin: 0 0 15px 0;
}
.campos .testar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 20px 0 0 0;
}
.campos .testar p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.campos .testar a {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  text-decoration: underline;
  margin: 0 0 0 5px;
  transition: all 0.3s;
}
.campos .testar a:hover {
  color: var(--cor-verde);
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.erro {
    justify-content: center;
    align-items: flex-start;
    min-height: 100dvh;
    padding: 150px 10px 10px 10px;
  }
  img.efeito {
    right: -100px;
    bottom: auto;
    top: -200px;
    width: 700px;
    max-width: 700px;
  }
  video {
    max-width: 150px;
    right: auto;
    top: -10px;
    border: 5px solid #000000;
  }
  .quadro {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    right: auto;
    top: auto;
    padding: 50px 20px 50px 20px;
  }
  .titulo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .titulo h2 {
    font-size: var(--f3);
  }
}
</style>
